























import Vue from 'vue'
import iconCaretDown from '@/assets/svg/rounded/caret-down.svg?inline'

interface Props {
  filterValue: string
  filterName: string
}

interface Methods {
  textValue: (value: boolean) => string
}

interface Computed {
  newFilterValue: string
}

export default Vue.extend<{}, Methods, Computed, Props>({
  components: {
    iconCaretDown,
  },
  props: {
    filterValue: {
      required: true,
    },
    filterName: {
      required: true,
    },
  },
  methods: {
    textValue(value) {
      return this.$tc(`records.${this.filterName}Value.${value}`)
    },
  },
  computed: {
    newFilterValue: {
      get() {
        return this.filterValue
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  mounted() {
    this.newFilterValue = this.filterValue || 'true'
  },
})
